<script lang="ts">
    import { checkoutData } from "../../../functionTools/cart"
    import { _ } from "svelte-i18n"
    import FormInputText from "../../widgets/Form/FormInputText.svelte"
    import { getCountriesList, getCountry } from "../../../api"
    import { initialLocale, langField } from "../../../i18n"
    import { maxInputLength, sameBillingAndDeliveryAddress } from "../../../../../api/hooks/config-client"
    import Select from "svelte-select/Select.svelte"
    import { selectTouchFix } from "../../../lib/actions/selectTouchFix"

    interface Props {
        hideHeadline?: boolean
    }

    let { hideHeadline = false }: Props = $props()

    const invalidate = () => {
        $checkoutData.stepsValid = 0
    }

    let shippingNote: string = $state()

    $effect(() => {
        shippingNote = ""
        let code = $checkoutData.deliveryAddress.countryCode
        if (code) {
            getCountry(code).then((c) => {
                if (langField(c?.note, "")) {
                    shippingNote = langField(c.note, "")
                }
            })
        }
    })

    let country: { label: string; value: string } | null = $state(null)
    let countries: { label: string; value: string }[] = $state([])
    getCountriesList().then((cs) => {
        countries = cs
            .filter((c) => c.valid_for_order)
            .map((c) => ({
                label: langField(c.name, ""),
                value: c.code,
            }))
        country = countries.find((c) => c.value === $checkoutData.deliveryAddress.countryCode) || null
    })
</script>

<section>
    {#if !hideHeadline}
        <div class="section_headline">
            {#if sameBillingAndDeliveryAddress}
                {$_("checkout.delivery-and-billing-address")}
            {:else}
                {$_("checkout.shipping-address")}
            {/if}
        </div>
    {/if}
    <div class="row">
        <div class="col-md-6">
            <FormInputText
                name="delivery_firstname"
                label="{$_('checkout.firstname')} / {$_('checkout.address-supplement')} ({$_('checkout.optional')})"
                bind:value={$checkoutData.deliveryAddress.firstname}
                onChange={invalidate}
                maxlength={maxInputLength.firstname}
            />
        </div>
        <div class="col-md-6">
            <FormInputText
                name="delivery_lastname"
                label="{$_('checkout.lastname')} / {$_('checkout.company')}"
                bind:value={$checkoutData.deliveryAddress.lastname}
                required
                onChange={invalidate}
                maxlength={maxInputLength.lastname}
            />
        </div>
    </div>
    <div class="row">
        <div class="col-md-12"></div>
        <div class="col-md-10">
            <FormInputText
                name="delivery_street"
                label={$_("checkout.street")}
                bind:value={$checkoutData.deliveryAddress.street}
                required
                onChange={invalidate}
                maxlength={maxInputLength.street}
            />
        </div>
        <div class="col-md-2">
            <FormInputText
                name="delivery_houseNumber"
                label={$_("checkout.house-number")}
                bind:value={$checkoutData.deliveryAddress.houseNumber}
                required
                onChange={invalidate}
                maxlength={maxInputLength.houseNumber}
            />
        </div>
        <div class="col-md-6">
            <FormInputText
                name="delivery_postcode"
                label={$_("checkout.postcode")}
                bind:value={$checkoutData.deliveryAddress.postcode}
                required
                onChange={invalidate}
                pattern={initialLocale == "de" ? "^\\d{5}$" : undefined}
                maxlength={maxInputLength.postcode}
            />
        </div>
        <div class="col-md-6">
            <FormInputText
                name="delivery_city"
                label={$_("checkout.city")}
                bind:value={$checkoutData.deliveryAddress.city}
                required
                onChange={invalidate}
                maxlength={maxInputLength.city}
            />
        </div>
    </div>
    <div class="row">
        <div class="col-md-12" use:selectTouchFix>
            {@html $_("checkout.delivery-country-notice-html")}<br /><br />
            <Select
                items={countries}
                inputAttributes={{ autocomplete: "off" }}
                placeholder="Land"
                showChevron={true}
                required={true}
                bind:value={country}
                on:change={(e) => {
                    if (e.detail.value) {
                        $checkoutData.deliveryAddress.countryCode = e.detail.value
                    }
                }}
            />
            {#if shippingNote}
                <div class="note">
                    {@html shippingNote}
                </div>
            {/if}
        </div>
    </div>
</section>
